let mainStore = {
  user: null,
};

export default mainStore;